import { render } from "./alertSys.vue?vue&type=template&id=290241c5&scoped=true"
import script from "./alertSys.vue?vue&type=script&lang=js"
export * from "./alertSys.vue?vue&type=script&lang=js"

import "./alertSys.vue?vue&type=style&index=0&id=290241c5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290241c5"]])

export default __exports__